let DataService = {};
DataService.setMaxEmployee = 100;
DataService.listHandleType = [
  {
    label: "Tất cả",
    value: "ALLOCATION"
  },
  {
    label: "Xử lý chính",
    value: "MAIN_PROCESS"
  },
  {
    label: "Xử lý phối hợp",
    value: "MIX_PROCESS"
  },
  {
    label: "Lấy ý kiến",
    value: "GET_FEEDBACK"
  },
],
DataService.listDocumentStatus = [
  {
    label: "Mới",
    value: "NEW"
  },
  {
    label: "Chờ xin ý kiến",
    value: "WAITING_COMMENT"
  },
  {
    label: "Đang xử lý",
    value: "PROCESSING"
  },
  {
    label: "Hoàn thành",
    value: "COMPLETED"
  },
],
DataService.listStatus = [
  {
    label: "Mới",
    value: "NEW"
  },
  {
    label: "Báo hỏng",
    value: "BROKEN_REPORT"
  },
  {
    label: "Xác nhận hỏng",
    value: "BROKEN_CONFIRMED"
  },
  {
    label: "Báo thu hồi",
    value: "RECALL_REPORT"
  },
  {
    label: "Xác nhận thu hồi",
    value: "RECALL_CONFIRMED"
  },
  {
    label: "Báo cấp phát",
    value: "ALLOCATION_REQUEST"
  },
  {
    label: "Xác nhận cấp phát",
    value: "ALLOCATION_CONFIRMED"
  },
  {
    label: "Thanh lý",
    value: "LIQUIDATION"
  },
  {
    label: "Hết",
    value: "OUT_OF_STOCK"
  },
],
// {
//   label: "Từ chối báo hỏng",
//   value: "BROKEN_REJECTED"
// },
// {
//   label: "Từ chối thu hồi",
//   value: "RECALL_REJECTED"
// },
// {
//   label: "Từ chối cấp phát",
//   value: "ALLOCATION_REJECTED"
// },
DataService.listAssetType = [
  {
    label: "Cấp phát",
    value: "ALLOCATION"
  },
  {
    label: "Thu hồi",
    value: "RECALL"
  },
  {
    label: "Báo hỏng",
    value: "BROKEN"
  },
  {
    label: "Thanh lý",
    value: "LIQUIDATION"
  },
],
DataService.listGioiTinh = [
  /* An array of objects. */
  {
    value: 0,
    label: "Nữ"
  },
  {
    value: 1,
    label: "Nam"
  },
  {
    value: 2,
    label: "Khác"
  }
];

DataService.listTrangThaiLamViec = [
  {
    value: "DANG_LAM_VIEC",
    label: "Đang làm việc"
  },
  {
    value: "DA_NGHI",
    label: "Đã nghỉ"
  },
  {
    value: "NGHI_SINH",
    label: "Nghỉ sinh"
  },
  {
    value: "DANG_LAM_VIEC,NGHI_SINH",
    label: "Đang làm việc & Nghỉ sinh"
  }
];

DataService.listLoaiLyDo = [
  {
    value: "DAY_OFF",
    label: "Nghỉ làm"
  },
  {
    value: "GO_LATE",
    label: "Đi muộn"
  },
  {
    value: "COME_BACK_SOON",
    label: "Về sớm"
  },
  {
    value: "WORK_EXPLANATION",
    label: "Giải trình công"
  },
  {
    value: "GO_OUT",
    label: "Ra ngoài"
  },
  {
    value: "GO_ON_BUSSINESS",
    label: "Công tác"
  },
  {
    value: "TIME_KEEPING_ONLINE",
    label: "Chấm công online"
  },
  {
    value: "WIFI_ATTENDANCE",
    label: "Điểm danh thủ công"
  },
  {
    value: "OT",
    label: "Làm thêm giờ"
  }
];
DataService.listTrangThai = [
  {
    value: "",
    label: "Tất cả ",
    name: "ALL"
  },
  {
    value: "WAITING_FOR_APPROVAL",
    label: "Chờ duyệt",
    name: "WAITING_FOR_APPROVAL"
  },
  {
    value: "APPROVED",
    label: "Đã duyệt",
    name: "APPROVED"
  },
  {
    value: "REJECTED",
    label: "Từ chối",
    name: "REJECTED"
  }
];
DataService.listLoaiLyDoNghi = [
  {
    value: "LEAVE_WITH_PAY",
    label: "Nghỉ có lương"
  },
  {
    value: "LEAVE_WITHOUT_PAY",
    label: "Nghỉ không lương"
  }
];

DataService.listLoaiNgayNghi = [
  {
    value: "HOLIDAY",
    label: "Nghỉ lễ"
  },
  {
    value: "HOLIDAY_RDO",
    label: "Nghỉ bù lễ"
  },
  {
    value: "OTHER",
    label: "Nghỉ khác"
  }
];
DataService.listChuKyLap = [
  {
    value: "WEEKLY",
    label: "Hằng tuần"
  },
  {
    value: "EVEN_WEEK_OF_MONTH",
    label: "Cách tuần chẵn"
  },
  {
    value: "ODD_WEEK_OF_MONTH",
    label: "Cách tuần lẻ"
  },
  {
    value: "WEEK_1_OF_MONTH",
    label: "Tuần 1 của tháng"
  },
  {
    value: "WEEK_2_OF_MONTH",
    label: "Tuần 2 của tháng"
  },
  {
    value: "WEEK_3_OF_MONTH",
    label: "Tuần 3 của tháng"
  },
  {
    value: "WEEK_4_OF_MONTH",
    label: "Tuần 4 của tháng"
  },
  {
    value: "WEEK_5_OF_MONTH",
    label: "Tuần 5 của tháng"
  },
  {
    value: "NEAR_LAST_WEEK_OF_MONTH",
    label: "Tuần áp cuối của tháng"
  },
  {
    value: "LAST_WEEK_OF_MONTH",
    label: "Tuần cuối cùng của tháng"
  }
];

DataService.listQuyDoiCong = [
  {
    value: "0.125",
    label: "0.125"
  },
  {
    value: "0.25",
    label: "0.25"
  },
  {
    value: "0.5",
    label: "0.5"
  },
  {
    value: "1",
    label: "1"
  }
];

DataService.listTinhCong = [
  {
    value: "WORK",
    label: "Ca hành chính"
  },
  {
    value: "HOUR",
    label: "Khác"
  }
];

DataService.listTrangThaiKhoa = [
  {
    value: "false",
    label: "Không khóa"
  },
  {
    value: "true",
    label: "Khóa"
  }
];

DataService.listThoiGianDiMuonVeSom = [
  {
    value: 0,
    label: "0 phút"
  },
  {
    value: 15,
    label: "15 phút"
  },
  {
    value: 30,
    label: "30 phút"
  },
  {
    value: 45,
    label: "45 phút"
  },
  {
    value: 60,
    label: "60 phút"
  }
];

DataService.listSocialMediaNetwork = [
  {
    value: "facebook",
    label: "Facebook"
  },
  {
    value: "linkedIn",
    label: "LinkedIn"
  },
  {
    value: "skype",
    label: "Skype"
  },
  {
    value: "telegram",
    label: "Telegram"
  },
  {
    value: "twitter",
    label: "Twitter"
  }
];

DataService.listTypeContractOrDocument = [
  {
    value: "CONTRACT",
    label: "Hợp đồng"
  },
  {
    value: "DOCUMENT",
    label: "Văn bản"
  }
];

DataService.listKindOfContract = [
  {
    value: "LABOR",
    label: "Lao động"
  },
  {
    value: "PERSONNEL",
    label: "Dân sự"
  },
]

DataService.listStatusOfContract = [
  {
    value: "DRAFF",
    label: "Nháp"
  },
  {
    value: "GENERATING",
    label: "Đang kết xuất"
  },
  {
    value: "FAILED",
    label: "Kết xuất lỗi"
  },
  {
    value: "COMPLETED",
    label: "Chờ trình ký"
  },
  {
    value: "SIGN_WAITING",
    label: "Chờ ký"
  },
  {
    value: "SIGN_APPROVED",
    label: "Đã ký"
  },
  {
    value: "SIGN_REJECTED",
    label: "Từ chối"
  },
]

/* An array of colors. */
DataService.listColors =
[
  '#FFA600',
  '#56CCF2',
  '#FF5A5A',
  '#30DA88',
  '#6600FF',
  '#5787A4',
  '#BCE29E',
  '#FCE700',
  '#400D51',
  '#002B5B',
  '#80558C',
  '#FD8A8A',
  '#3A4F7A',
  '#FF6E31',
  '#0A2647',
  '#86C8BC',
  '#DC0000',
  '#2B3467',
  '#7F167F',
  '#6D67E4',
  '#2B3A55',
  '#CE7777',
  '#2A3990',
  '#6ECCAF',
  '#8B7E74',
]

DataService.listDocumentOp = [
  {
    label: 'Văn bản đến nhận từ công ty ngoài',
    value: 'EXTERNAL_DOC_IN',
  },
  {
    label: 'Văn bản chuyển đi công ty ngoài',
    value: 'EXTERNAL_DOC_OUT',
  },
  {
    label: 'Văn bản nội bộ',
    value: 'INTERNAL_DOC',
  },
]


export default DataService;
